<template>
	<div class="meta-grid mb-3" v-if="passedMaterial">
		<div class="row mb-1 mx-0">
			<h4 class="mr-auto">{{ product.name }}</h4>
		</div>

		<div class="row mx-0">
			<div class="col-4 px-0">EAN</div>
			<div class="col-8 px-0 text-left">{{ passedMaterial.ean }}</div>
		</div>

		<div
				v-if="passedMaterial.eans && passedMaterial.eans.length !== 0"
				class="row mx-0"
		>
			<div class="col-4 px-0">
				Zusatz EAN<span v-if="passedMaterial.eans.length > 1">s</span>
			</div>
			<div class="col-8 px-0 text-left">
				<p
						v-for="additionalEan in passedMaterial.eans"
						:key="additionalEan.ean"
						class="my-0"
				>
					{{ additionalEan.ean }} ({{ additionalEan.origin }})
				</p>
			</div>
		</div>

		<div class="row mx-0">
			<div class="col-4 px-0">Kategorie</div>
			<div v-if="changingCategory === false" class="col-8 px-0 text-left">
				{{ productCategoryName}}
				<span class="icon icon-pencil" @click="editCategory"></span>
			</div>

			<div v-else class="col-8 px-0 d-flex">
				<select v-model="selectedCategory" class="form-control form-control-sm">
					<option
							v-for="category in categoryOptions"
							:key="category.categoryId"
							:value="category.categoryId"
					>
						{{ category.uiName }}
					</option>
				</select>

				<button type="button" class="btn btn-secondary btn-sm ml-1" @click="saveCategory">
					<span class="icon icon-checkmark"></span>
				</button>

				<button type="button" class="btn btn-secondary btn-sm ml-1" @click="cancelCategoryEdit">
					<span class="icon icon-cross"></span>
				</button>
			</div>
		</div>

		<div class="row mx-0">
			<div class="col-4 px-0">ASIN</div>
			<div class="col-8 px-0 text-left">{{ product.asin }}</div>
		</div>

		<div class="row mx-0">
			<div class="col-4 px-0">US-HS-Code</div>
			<div v-if="changingHsCode === false" class="col-8 px-0 text-left">
<!--				{{ product.hsCodeUS}}-->
				{{ product.hsCodeUs ? product.hsCodeUs : '-'}}
				<span class="icon icon-pencil" @click="editHsCode"></span>
			</div>

			<div v-else class="col-8 px-0 d-flex">
			<input v-model="selectedHsCodeUs" class="form-control form-control-sm" type="text" maxlength="10"/>

				<button type="button" class="btn btn-secondary btn-sm ml-1" @click="saveHsCode">
					<span class="icon icon-checkmark"></span>
				</button>

				<button type="button" class="btn btn-secondary btn-sm ml-1" @click="cancelHsCodeEdit">
					<span class="icon icon-cross"></span>
				</button>
			</div>
		</div>

		<div v-if="passedMaterial.isUndeliverable" class="row mx-0">
			<div class="col-4 px-0"></div>
			<div class="col-8 px-0 text-left">
				<b class="text-danger">Lieferverzögerung</b>
			</div>
		</div>
	</div>
		<b-modal
				v-model="showConfirm"
				centered
				ok-title="Bestätigen"
				cancel-title="Abbrechen"
				title="Kategorie ändern"
				@ok="confirmCategoryChange"
		>
			<p class="mb-0">{{ confirmText }}</p>
		</b-modal>

	<modal-error-component v-model="modalError"></modal-error-component>
</template>

<script>
import ModalErrorComponent from "../../ModalErrorComponent.vue";

export default {
	name: "ProductIdentifiers",
	components: {ModalErrorComponent},
	props: {
		passedMaterial: {
			type: Object,
			required: true
		},
		productCategories: {
			type: Object,
			required: true
		}
	},
	data() {
		return {
			categoryMap: [],
			product: this.passedMaterial.product,
			changingCategory: false,
			selectedCategory: null,
			changingHsCode: false,
			selectedHsCodeUs: null,
			showConfirm: false,
			confirmText: '',
			modalError:
				{
					show: false,
					title: 'Speichern',
					message: 'Der Speichervorgang konnte aufgrund eines Fehlers nicht durchgeführt werden.',
					error: '',
				},
			CATEGORY_MANUALLY_SET: 16777216,
		}
	},
	computed: {
		productCategoryName() {
			const categoryId = this.product?.category;

			const category = Object.values(this.productCategories)
					.find(category => category.categoryId == categoryId);

			return category?.uiName || '-';
		},
		categoryOptions() {
			return Object.values(this.productCategories);
		},
	},
	methods: {
		editCategory() {
			this.changingCategory = true;
			this.selectedCategory = this.product?.category || null;
		},
		cancelCategoryEdit() {
			this.changingCategory = false;
			this.selectedCategory = null;
		},

		saveCategory() {
			const oldName = this.productCategoryName;

			const newName = Object.values(this.productCategories)
					.find(c => c.categoryId == this.selectedCategory)?.uiName || '-';

			this.confirmText = `Kategorie wirklich ändern von "${oldName}" zu "${newName}"?`;
			this.showConfirm = true;
		},
		confirmCategoryChange() {
			this.passedMaterial.product.category = this.selectedCategory;
			this.save();
			this.changingCategory = false;
		},
		save()
		{
			this.product.manualUpdateOverride = true;
			this.product.flags |= this.CATEGORY_MANUALLY_SET;
			axios.put('/mds/product', this.product)
					.then( response => {
						this.product = response.data;
					}).catch( error => {
				this.modalError = {
					show: true,
					title: 'Speichern',
					message: "Der Speichervorgang konnte aufgrund eines serverseitigen Fehlers nicht ausgeführt werden.",
					error: error.toString()
				};
				axios.get(`/mds/product/${this.product.asin}`).then( response => {
					this.product = response.data;
				}).catch( error => console.log(error) );
			});
		},

		editHsCode() {
			this.changingHsCode = true;
			this.selectedHsCodeUs = this.product?.hsCodeUs || null;
		},
		cancelHsCodeEdit() {
			this.changingHsCode = false;
			this.selectedHsCodeUs = null;
		},
		isValidHsCode() {
			if (this.selectedHsCodeUs.length > 10) {
				alert("Der HS-Code darf maximal 10 Zeichen lang sein.");
				return false;
			}
			if(this.selectedHsCodeUs.length < 10) {
				alert("Der US-HS-Code sollte 10 Zeichen lang sein. Bitte überprüfen Sie die Eingabe.");
				return false;
			}
			return true;
		},
		saveHsCode() {
			if(!this.isValidHsCode()) return;

			axios.put('/mds/product/hscode', {hsCodeUs: this.selectedHsCodeUs, asin: this.product.asin})
					.then( response => {
						console.log("HS Code saved successfully:", response.data);
						this.product = response.data;
						this.changingHsCode = false;
					}).catch( error => {
				console.log(error);
				this.modalError = {
					show: true,
					title: 'Speichern',
					message: "Der Speichervorgang konnte aufgrund eines serverseitigen Fehlers nicht ausgeführt werden.",
					error: error?.response?.data?.error ?? error.toString()
				};
				axios.get(`/mds/product/${this.product.asin}`).then( response => {
					this.product = response.data;
				}).catch( error => console.log(error) );
			});
		}
	}
}
</script>


<style scoped>
.meta-grid {
	line-height: 2;
	margin-top: -3px;
}

.meta-grid .row {
	align-items: center;
}

.meta-grid .col-4 {
	white-space: nowrap;
}
</style>